<template>
  <div class="cases-bg">
    <div class="cases adaption-right-full">
      <div class="headline-container">
        <div class="headline himalaya">P<span>artner</span></div>
        <span class="title">合作伙伴</span>
        <div class="br-line"></div>
        <div class="text himalaya">了解双湃是如何协助他们完成工业安全实施</div>
        <div class="Wayra cases-btn" @click="click">更多案例</div>
      </div>
      <div class="logo-card">
        <div class="card-tab">
          <div v-for="(item, key, index) in tab" :key="key" class="tab">
            <div class="name" :class="active===key?'active':''" @click="tabClick(key, index)">
              {{ item.name }}
            </div>
            <div class="card-body" :class="active===key?'active':''">
              <div class="logo-container" :class="active===key?'active':''">
                <img class="logo" v-for="i in item.img" :key="i"
                     v-lazy="require(`../../assets/index/cases/${key}/${i}.png`)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {top} from "../../utils/common";

export default {
  name: "Cases",
  data() {
    return {
      tab: {
        university: {
          name: "高校",
          img: 11
        },
        enterprise: {
          name: "工业企业",
          img: 17
        },
        platform: {
          name: "互联网平台",
          img: 13
        },
        scientific: {
          name: "科研院所",
          img: 8
        }
      },
      active: "university",
      index: 0,
      Interval: null
    };
  },
  methods: {
    click() {
      top();
      this.$router.push("/case");
    },
    tabClick(key, index) {
      this.active = key;
      this.index = index;
      this.play();
    },
    play() {
      this.clear();
      let keys = Object.keys(this.tab);

      this.Interval = setInterval(() => {
        this.index >= keys.length - 1 ? this.index = 0 : this.index++;
        this.active = keys[this.index];
      }, 5000);
    },
    clear() {
      if (this.Interval) {
        clearInterval(this.Interval);
      }
    }
  },
  mounted() {
    this.play();
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style scoped lang="less">
.cases-bg {
  height: 774px;
  background: url("../../assets/index/cases/bg.png") center;
}

.cases {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 100%;
  overflow: hidden;

  & > div {
    padding-top: 80px;
  }

  .headline-container {
    width: 350px;
  }

  .headline {
    width: 250px;
    height: 85px;
    font-size: 120px;
    color: #929AB9;

    span {
      font-size: 70px;
    }
  }

  .title {
    font-size: 36px;
    color: #FFFFFF;
  }

  .br-line {
    width: 92px;
    margin-top: 10px;
    border-bottom: 3px solid #FFFFFF;
  }

  .text {
    margin-top: 40px;
    font-size: 18px;
    color: #FFFFFF;
  }

  .cases-btn {
    width: 203px;
    margin-top: 40px;
    font-size: 18px;
    text-align: center;
  }
}

.logo-card {
  width: calc(100% - 400px);
  margin-left: 50px;

  .card-tab {
    position: relative;

    .tab {
      display: inline-block;

      .name {
        margin-right: 45px;
        font-size: 18px;
        line-height: 23px;
        color: #919191;
        cursor: pointer;

        &.active {
          transition: color 0.3s, font-size 0.3s;
          font-size: 24px;
          line-height: 32px;
          color: #FFFFFF;
          border-bottom: 4px solid #224895;
        }
      }

      .card-body {
        position: absolute;
        left: 0;
        visibility: hidden;

        &.active {
          visibility: visible;
        }

        .logo-container {
          margin-top: 40px;
          opacity: 0;

          &.active {
            transition: opacity 0.6s;
            opacity: 1;
          }

          .logo {
            height: 68px;
            margin-bottom: 24px;
            margin-right: 30px;
          }
        }
      }
    }
  }
}
</style>
